import { Shadows } from '@mui/material/styles/shadows';
import { PaletteMode } from '@mui/material';

// Custom shadows with better contrast
export const shadows = (mode: PaletteMode): Shadows => {
  // Use lighter shadows for dark mode
  const shadowOpacity = mode === 'dark' ? 0.7 : 1;
  
  return [
    'none',
    `0px 2px 4px rgba(0, 0, 0, ${0.05 * shadowOpacity})`,
    `0px 4px 6px rgba(0, 0, 0, ${0.07 * shadowOpacity})`,
    `0px 6px 8px rgba(0, 0, 0, ${0.1 * shadowOpacity})`,
    `0px 8px 12px rgba(0, 0, 0, ${0.12 * shadowOpacity})`,
    `0px 10px 14px rgba(0, 0, 0, ${0.14 * shadowOpacity})`,
    `0px 12px 16px rgba(0, 0, 0, ${0.15 * shadowOpacity})`,
    `0px 14px 18px rgba(0, 0, 0, ${0.16 * shadowOpacity})`,
    `0px 16px 20px rgba(0, 0, 0, ${0.17 * shadowOpacity})`,
    `0px 18px 22px rgba(0, 0, 0, ${0.18 * shadowOpacity})`,
    `0px 20px 24px rgba(0, 0, 0, ${0.19 * shadowOpacity})`,
    `0px 22px 26px rgba(0, 0, 0, ${0.2 * shadowOpacity})`,
    `0px 24px 28px rgba(0, 0, 0, ${0.21 * shadowOpacity})`,
    `0px 26px 30px rgba(0, 0, 0, ${0.22 * shadowOpacity})`,
    `0px 28px 32px rgba(0, 0, 0, ${0.23 * shadowOpacity})`,
    `0px 30px 34px rgba(0, 0, 0, ${0.24 * shadowOpacity})`,
    `0px 32px 36px rgba(0, 0, 0, ${0.25 * shadowOpacity})`,
    `0px 34px 38px rgba(0, 0, 0, ${0.26 * shadowOpacity})`,
    `0px 36px 40px rgba(0, 0, 0, ${0.27 * shadowOpacity})`,
    `0px 38px 42px rgba(0, 0, 0, ${0.28 * shadowOpacity})`,
    `0px 40px 44px rgba(0, 0, 0, ${0.29 * shadowOpacity})`,
    `0px 42px 46px rgba(0, 0, 0, ${0.3 * shadowOpacity})`,
    `0px 44px 48px rgba(0, 0, 0, ${0.31 * shadowOpacity})`,
    `0px 46px 50px rgba(0, 0, 0, ${0.32 * shadowOpacity})`,
    `0px 48px 52px rgba(0, 0, 0, ${0.33 * shadowOpacity})`,
  ];
};